module.exports = __webpack_public_path__ + "img/image28.0419bc6b.jpg";